<!--
- 报告列表组件
- anthor: wang.y
- greatTime: 2019-10-30
-->
<template>
    <li>
        <div class="content-container">
          <div class="report-img" @click="goDetail(dataLi)">
            <span class="report-type" v-if="filter.dealName(dataLi.category_id, report_type) != '--'">{{dataLi.category_id | dealName(report_type)}}</span>
            <img :src="dataLi.logo_path | logo_show" />
          </div>
          <div class="report-info">
              <div class="report-title" @click="goDetail(dataLi)" v-html="filter.keyWordHighLight(dataLi.title, keyword)"></div>
              <div class="report-summary" @click="goDetail(dataLi)" v-html="filter.keyWordHighLight(dataLi.summary, keyword)"></div>
              <div class="report-dec">
                  <div class="report-price">
                      <template v-if="dataLi.price > 0"><span>￥</span>{{dataLi.price}}</template>
                      <template v-else>免费</template>
                  </div>
                  <div class="report-src" v-if="dataLi.src_author !== ''"><i class="iconfont">&#xe645;</i>{{dataLi.src_author}}</div>
                  <div class="report-time"><i class="iconfont">&#xe632;</i>{{dataLi.publish_time | timeTrans}}</div>
                  <div class="collect_share">
                      <i class="iconfont s active" title="取消收藏" v-if="dataLi.is_collect > 0" @click="cancelCollect('1', dataLi.id, delCollectCb)">&#xe66f;</i>
                      <i class="iconfont s" title="收藏" v-else  @click="addCollect('1', dataLi.id, addCollectCb)">&#xe66f;</i>
                  </div>
              </div>
          </div>
        </div>
        <div class="highlight-list" :class="[theme]" v-if="dataLi.highlight.length != 0">
          <div class="left">
            <div v-for="(item,index) in (open?dataLi.highlight:dataLi.highlight.slice(0, 2))" :key="index" v-html="'...'+item"></div>
          </div>
          <div class="right" @click="open = !open" v-if="dataLi.highlight.length > 2">
            {{open?'收起':'展开'}}<i class="iconfont" v-html="open?'&#xe63b;':'&#xe648;'"></i>
          </div>
        </div>
        <Modal
            v-model="reportIndex"
            @on-visible-change="reportModalCancel"
            :footer-hide="true"
            width="458"
            class="page-modal"
        >
            <img :src="$store.state.static_img_url + 'pic/model/report-upload-model.png'" />
            <p class="p1">亲，今日下载量已耗尽~</p>
            <p class="p2">成为VIP会员， 下载量不受限。</p>
            <router-link to="/buyVip" class="go-vip-btn">立即成为VIP会员</router-link>
        </Modal>
    </li>
</template>

<script>
import { getNumOfreadReport } from '../../../service'
import filter from 'js/filter'
import { userInfo } from 'js/userInfo'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [userInfo,collect_mixin],
  inject: ['login'],
  props: ['dataLi', 'keyword'],
  data() {
    return {
      filter: filter,
      had_read_report: [],
      reportIndex: false,

      open: false // 展开和收起
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme_switch?'light':'dark'
    }
  },
  methods: {
    addCollectCb() {
      this.dataLi.is_collect = 1
    },
    delCollectCb() {
      this.dataLi.is_collect = 0
    },
    goDetail(item) {
      if(this.user_key) {
        if(item.price > 0) {
          // this.$router.push({name: 'ReportDetail', params: {uid: item.uid}})
          const { href } = this.$router.resolve({
            name: "ReportDetail",
            params: {
              uid: item.uid
            }
          })
          window.open(href, '_blank')
        } else {
          if (this.had_read_report.indexOf(item.id) == -1) {
            this.getNumOfreadReport(item.uid)
          } else {
            let q = JSON.stringify({user_key: this.user_key, uid: item.uid})
            window.open(this.$store.state.req_url + '/dg/reportfile?query=' + q)
          }
        }
      } else {
        this.login()
      }
    },
    /**
     * 统计用户查看的免费报告篇数
     */
    async getNumOfreadReport(uid) {
      let res = await getNumOfreadReport( {user_key: this.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if(res.res < 10 || this.isVIP) {
          let q = JSON.stringify({user_key: this.user_key, uid: uid})
          window.open(this.$store.state.req_url + '/dg/reportfile?query=' + q)
        } else {
          this.reportIndex = true
        }
        this.had_read_report = res.report_ids
      } else {
        this.$Message.error(res.message)
      }
    },
    reportModalCancel(value) {
      this.reportIndex = value
    }
  }
}

</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
li
  padding: 20px 0 0
  .content-container
    display: flex
  &+li
    // border-top: 1px solid
    // commonBorderColor(#40444F, #F3F3F3)
    margin-top 16px
  .report
    &-img
      position: relative
      flex: 0 0 200px
      height: 120px
      overflow: hidden
      cursor: pointer
      img
        width: 100%
        height: 100%
        transition_02s()
      &:hover
        img
          transform: scale(1.05, 1.05)
    &-type
      position: absolute
      background: #373737
      color: #FFFFFF
      font-size: 12px
      padding: 3px 10px
      top: 5px
      left: 5px
      z-index: 2
    &-info
      margin-left: 20px
      position: relative
      flex: auto
    &-title
    &-summary
      font-size:18px
      font-weight:600
      commonColor(#e9e9eb, #333333)
      line-height:26px
      max-height: 52px
      display: -webkit-box
      overflow: hidden
      text-overflow: ellipsis
      word-break: break-all
      -webkit-box-orient: vertical
      -webkit-line-clamp: 2
      cursor: pointer
      &:hover
        color: rgba(250, 122, 80, 1) !important
    &-summary
      font-size:14px
      font-weight:400
      commonColor(#bcbdc1, #666666)
      line-height:22px
      max-height: 44px
    &-dec
      position: absolute
      bottom: 0
      left: 0
      width: 100%
      display: flex
      justify-content: flex-end
    &-price
      font-size:16px
      font-weight:600
      color:#FFC069
      line-height:22px
      flex: auto
      span
        font-size:12px
    &-src
    &-time
      font-size:12px
      font-weight:400
      commonColor(#bcbdc1, #999999)
      line-height: 22px
      text-align: right
      margin-left: 30px
      i
        commonColor(#bcbdc1, #CCCCCC)
        vertical-align: top
        margin-right: 6px
  >>> .high-light
    color: rgba(250, 122, 80, 1) !important
    font-style: normal
  .collect_share
    margin-left: 30px
    display: flex
    align-items: center
  .highlight-list
    margin-top 14px
    padding 12px 20px
    position relative
    commonBgColor(#2A2F42, #F9F9F9)
    display flex
    align-items flex-end
    commonColor(#bcbdc1, #666666)
    font-size 14px
    &:before
      content ''
      display block
      position absolute
      top -10px
      left 90px
      border-bottom-width 10px
      border-bottom-style solid
      // commonBorderBottomColor(#2A2F42, #F9F9F9)
      border-left 10px solid transparent
      border-right 10px solid transparent
    &.light:before 
      border-bottom-color #F9F9F9
    &.dark:before 
      border-bottom-color #2A2F42
    .left
      flex 1
      div
        line-height 22px
        height 22px
        display -webkit-box
        overflow hidden
        text-overflow ellipsis
        word-break break-all
        -webkit-box-orient vertical
        -webkit-line-clamp 1
        >>> em
          color #FA7A50
        &:before
          content ''
          display inline-block
          width 6px
          height 6px
          background #FA7A50
          margin-right 8px
          transform translateY(-2px)
        &+div
          margin-top 4px
    .right 
      width 46px
      margin-left 22px
      font-size 12px
      color #FA7A50
      cursor pointer
      i
        margin-left 5px
        font-size 12px
.page-modal
  >>> .ivu-modal
    top: 50%
    margin-top: -140px
  >>> .ivu-modal-content
    border-radius: 0
    height: 280px
    background: url('~pic/model/vip-model.png') no-repeat
    background-size: 100%
    .ivu-modal-close
      right: 8px
      top: 8px
      .ivu-icon-ios-close
        color: #ddd
        &:hover
          color: #553204
  >>> .ivu-modal-body
    padding: 0
    text-align: center
    font-size: 0
    img
      width: 120px
      height: 120px
      margin-top: -55px
    .p1
      color: #553204
      font-size: 24px
      font-weight:600
      margin-top: 22px
    .p2
      color: #553204
      font-size: 16px
      margin-top: 12px
    .go-vip-btn
      inlineBlock()
      width:150px
      height:40px
      background:rgba(255,234,197,1)
      border-radius:20px
      color: #553204
      font-size:14px
      text-align: center
      line-height: 40px
      margin-top: 40px
</style>
